<template>
  <div class="game-wrapper">
    <counter token-type="gold" :initial-value="2" />
    <counter token-type="strength" />
    <counter token-type="magic" :initial-value="1" />
    <counter token-type="victory-points" />
    <div class="bottom-link">
      <span @click="toggleResetOverlay">Finish Game</span>
    </div>
    <div v-if="overlayIsShown" class="overlay-wrapper">
      
      <div class="overlay">
        <h2>Are you sure?</h2>
        <p class="tempered-text">Finishing the game will reset all counters and take you back to the home screen.</p>
        <custom-button class="reset-button">
          <a @click="finishGame">Finish &amp; Reset</a>
        </custom-button>
        <p @click="toggleResetOverlay" class="cancel">Cancel</p>
      </div>
      <div  @click="toggleResetOverlay" class="overlay-background" />
    </div>
  </div>
</template>

<script>
import Counter from '@/components/Counter.vue'
import CustomButton from '@/components/CustomButton.vue'

export default {
  name: 'Game',
  components: {
    Counter,
    CustomButton
  },
  data() {
    return {
      overlayIsShown: false,
    }
  },
  mounted() {
    localStorage['gameInProgress'] = 'true';
  },
  methods: {
    toggleResetOverlay() {
      this.overlayIsShown = !this.overlayIsShown;
    },
    finishGame() {
      if(localStorage['gold']) {
        localStorage['gold'] = 2;
      }
      if(localStorage['strength']) {
        localStorage['strength'] = 0;
      }
      if(localStorage['magic']) {
        localStorage['magic'] = 1;
      }
      if(localStorage['victory-points']) {
        localStorage['victory-points'] = 0;
      }
      localStorage['gameInProgress'] = 'false';
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
.game-wrapper {
  font-family: 'Simonetta';
  font-style: normal;
  font-size: 19px;
  max-width: 650px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media(max-height: 570px) {
  .game-wrapper {
    justify-content: start;
  }
}

.bottom-link {
font-size: 16px;
line-height: 76.5%;
text-align: center;
color: rgba(0, 0, 0, 0.5);
margin: 30px 0;
user-select: none;
}

.bottom-link > span {
  display: inline-block;
  padding: 20px;
  cursor: pointer;
}

.overlay-wrapper {
  position: absolute;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-background {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-color:rgba(0, 0, 0, 0.5)
}

.overlay {
  background-color: white;
  padding: 30px;
  max-width: 400px;
  border-radius: 20px;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.36);
}

.reset-button {
  margin: 30px 0;
}

.cancel {
  color: #93267B;
  cursor: pointer;
  user-select: none;
}

.tempered-text {
  opacity: 0.7;
}
</style>
